import React, { useState } from "react";
import Modal from "../../shared/Modal";

const NewMessageModal = ({ isOpen, onClose, recipients = [], onSend }) => {
  const [messageType, setMessageType] = useState("email");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRecipients, setSelectedRecipients] = useState(new Set());

  const handleSubmit = (e) => {
    e.preventDefault();
    onSend({
      type: messageType,
      subject,
      message,
      recipients: Array.from(selectedRecipients),
    });
    onClose();
  };

  const toggleRecipient = (recipientId) => {
    const newSelected = new Set(selectedRecipients);
    if (newSelected.has(recipientId)) {
      newSelected.delete(recipientId);
    } else {
      newSelected.add(recipientId);
    }
    setSelectedRecipients(newSelected);
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      width="large"   // Use large size (544px) for message composer
    >
      <div className="p-6 bg-white dark:bg-gray-800 rounded-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            New Message
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Message Type Selection */}
          <div className="flex space-x-4 p-2 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <button
              type="button"
              onClick={() => setMessageType("email")}
              className={`flex-1 py-2 px-4 rounded-md transition-colors ${
                messageType === "email"
                  ? "bg-blue-600 text-white"
                  : "bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500"
              }`}
            >
              Email
            </button>
            <button
              type="button"
              onClick={() => setMessageType("text")}
              className={`flex-1 py-2 px-4 rounded-md transition-colors ${
                messageType === "text"
                  ? "bg-blue-600 text-white"
                  : "bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500"
              }`}
            >
              Text Message
            </button>
          </div>

          {/* Recipients */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Recipients
            </label>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {recipients.map((recipient) => (
                <label
                  key={recipient.userId}
                  className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={selectedRecipients.has(recipient.userId)}
                    onChange={() => toggleRecipient(recipient.userId)}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700"
                  />
                  <span className="text-gray-900 dark:text-gray-100">
                    {recipient.firstName} {recipient.lastName}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Subject (for email only) */}
          {messageType === "email" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Subject
              </label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                placeholder="Enter subject"
              />
            </div>
          )}

          {/* Message Content */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Message
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={messageType === "email" ? 8 : 4}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              placeholder={`Type your ${messageType} message here...`}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 dark:focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-white bg-blue-600 dark:bg-blue-500 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NewMessageModal; 